// extracted by mini-css-extract-plugin
export default {"container":"c_-z","tab":"d_-z","selected":"e_-z"};